module.exports = __webpack_public_path__ + "img/icon_map_penguan_zaixian.757ad0ac.svg";